import controller from './__init/controller';

controller.init();

window.onload = () => {
    controller.loaded();
};
window.onresize = () => {
    controller.resized();
};

window.onscroll = () => {
    controller.scrolled();
};

jQuery(document).on('orientationchange', () => {
    controller.orientation();
});

jQuery(window).bind('orientationchange', () => {
    controller.orientationMob();
});

// window.addEventListener('orientationchange', () => {
//     controller.orientationMob();
// });
